// Line Execute — kind → unified ActionId mapping.
//
// Maps every `LineExecuteActionKind` enum value to its canonical
// ActionId in the unified action registry (src/services/actions/). Used by
// AiGeneratorPanel to look up `action.tourId` on DISPATCHED+COMPLETED turns
// so the "Show me how" secondary button (U5) knows whether a registered tour
// is attached to the executed action.
//
// Only kinds with registered actions and intent-detector emitters are listed.

import type { ActionId } from '../../actions/action'

export type LineExecuteActionKind =
  | 'MEETING_SCHEDULE'
  | 'MEETING_CANCEL'
  | 'TIMELINE_STATUS_CHANGE'
  | 'CHECKLIST_TOGGLE_DONE'
  | 'CHAT_SEND'
  | 'MEMBER_INVITE'
  | 'REPORT_PREVIEW'
  | 'NAVIGATION'
  | 'FORM_SUBMIT'
  | 'EXPLORE_OPEN_PREVIEW'

/**
 * Stable mapping: LineExecuteActionKind → canonical ActionId in the unified
 * action registry. Only kinds that have a live adapter and a corresponding
 * `registerAction` call are listed here.
 *
 * This map is the single source of truth for U5 ("Show me how" secondary).
 * When a new adapter is added, add its entry here alongside its domain
 * registration.
 */
export const LINE_EXECUTE_KIND_TO_ACTION_ID: Partial<Record<LineExecuteActionKind, ActionId>> = {
  MEETING_SCHEDULE: 'meeting.schedule',
  MEETING_CANCEL: 'meeting.cancel',
  TIMELINE_STATUS_CHANGE: 'timeline.node.change-status',
  CHECKLIST_TOGGLE_DONE: 'checklist.node.toggle-done',
  CHAT_SEND: 'chat.message.send',
  REPORT_PREVIEW: 'report.preview',
  MEMBER_INVITE: 'member.invite.create',
  NAVIGATION: 'navigation.surface.open',
  EXPLORE_OPEN_PREVIEW: 'explore.preview.open',
  FORM_SUBMIT: 'form.response.submit',
}
